import { format as fnsFormat } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { formatRelativeDistanceToNow } from 'helpers/date';
import { FormatFunction } from 'i18next';
import { i18nDateFormats } from 'shared/constants';

import localesMap from './localesMap';

function isValidDate(value: string) {
    return !Number.isNaN(Date.parse(value));
}

export const formatDate: FormatFunction = (value, format, lng, options) => {
    if (!lng || !localesMap[lng] || !isValidDate(value)) {
        return value;
    }

    const locale = localesMap[lng]?.i18nLocale;
    const datePattern = format ? i18nDateFormats[format]?.(options) : null;

    if (datePattern) {
        const valueTz = options?.['tenantTz'] ? toZonedTime(value, options['tenantTz']) : new Date(value);

        return fnsFormat(valueTz, datePattern, { locale });
    }

    if (format === 'distanceToNow') {
        return formatRelativeDistanceToNow(value, new Date(), options?.['tenantTz'] || 'UTC', locale);
    }   
};

export function getLocaleByLanguage(lng: string) {
    return localesMap[lng]?.i18nLocale || localesMap.en.i18nLocale;
}
